/* istanbul ignore file */

import nprogress from './nprogress.style'
import draftJs from './draft-js.style'
import tippyJsReact from './tippy-js-react.style'

export default `
  ${nprogress}
  ${draftJs}
  ${tippyJsReact}
`
